import { type IConfig } from '../types/configs';

import { generateUnionOfEditableFields } from '../helpers/fieldConfigParser';
import { fieldNameConverter } from '../helpers/fieldNameConverter';

let configs: Nullable<IConfig> = null;

export const setConfigs = (data: IConfig) => {
  configs = data;

  return {
    configs,
    unionOfEditableFields: generateUnionOfEditableFields(data.operations),
  };
};

export const resetFieldConfig = () => {
  configs = null;
};

export const getFieldMandatoryConfigValidation = (field: string) => (operation: string) => {
  const fieldName = fieldNameConverter(field);

  return !!configs?.operations?.[operation]?.mandatoryFields?.includes(fieldName);
};
